import React from 'react';
import CommonSection from '../commonSection/CommonSection';
import LegalText from '../../../online/components/legalText/LegalText';
import { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import CardApplyLink from '../cardApplyLink/CardApplyLink';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

const LegaInfoNewAccount: React.FC = () => {
  return (
    <CommonSection data-dd-privacy={PrivacyOptions.Allow}>
      <LegalText color={'primary'} dataAt="consents">
        By clicking &quot;Agree &amp; Continue&quot;, you agree to the terms of the (1){' '}
        <CardApplyLink data-at="arbitrationAgreement" href={`/document?documentType=${DocumentTypesTypes.CardApplicationArbitrationProvision}`} target="_blank">
          Arbitration Provision
        </CardApplyLink>
        ; (2){' '}
        <CardApplyLink data-at="electronicConsentLink" href={`/document?documentType=${DocumentTypesTypes.CardApplicationElectronicConsent}`} target="_blank">
          Electronic Communications Consent
        </CardApplyLink>
        ; (3){' '}
        <CardApplyLink data-at="privacyPolicyLink" href={`/document?documentType=${DocumentTypesTypes.CardApplicationPrivacyChoices}`} target="_blank">
          Privacy Policy
        </CardApplyLink>
        ; and (4){' '}
        <CardApplyLink data-at="onlineServicesTermsOfUseLink" href={`/document?documentType=${DocumentTypesTypes.CardApplicationOnlineServicesTermsOfUse}`} target="_blank">
          Terms of Use
        </CardApplyLink>
        .
      </LegalText>
    </CommonSection>
  );
};

export default LegaInfoNewAccount;
